<template>
  <div class="public-expand">
    <div class="public-expand-content ql-snow">
      <div
        :ref="refKey"
        class="ql-editor"
        v-html="item"
        :class="expanded ? 'show-text-all' : 'show-text-partial'"
      ></div>
      <a
        v-if="isOverflow"
        class="show-text-switch"
        :class="!expanded ? 'show-text-gradient' : ''"
        @click="expanded = !expanded"
      >
        <md-icon v-if="!expanded">expand_more</md-icon>
        <md-icon v-else>expand_less</md-icon>
      </a>
    </div>
  </div>
</template>

<script>
import Throttle from 'lodash.throttle';

export default {
  props: {
    item: {
      type: String,
      required: true,
    },
    refKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      isOverflow: false,
      throttled: null,
      isOpened: false,
    };
  },
  mounted() {
    this.throttled = Throttle(this.handleResize, 500);
    window.addEventListener('resize', this.throttled);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.throttled);
  },
  methods: {
    handleResize() {
      if (!this.isOpened) {
        let container = this.$refs[this.refKey];
        this.isOverflow = container.scrollHeight > container.clientHeight;
        this.expanded = false;
        this.isOpened = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-expand.scss';
</style>
